import React, {useState, useEffect} from 'react';
import {
    Modal, Grid, TextField, InputLabel, CardHeader, Button, Card, CardActions, Select, MenuItem
} from '@material-ui/core';
import InputMask from 'react-input-mask';
import {makeStyles} from '@material-ui/core/styles';
import axios from "../../api";
import Swal from "sweetalert2";


//modal de constal que define o modal de funcionario
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        backgroundColor: 'white',
    }, card: {
        padding: 20
    }
}));

const ModalFuncionarios = ({open, handleClose}) => {
    //define as contyantes para a unidade
    const [usuarios , setUsuarios] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [cargos, setCargos] = useState([]);
    const [consultorios, setConsultorios] = useState([]);
    const token = localStorage.getItem('token'); // ou outra forma de obter o token

    const [formValues, setFormValues] = useState({
        cpf: '',
        rg: '',
        data_nascimento: '',
        genero: '',
        cns: '',
        usuario_id: '',
        tipo_usuario_id: '',//cargo
        unidade_id: '',
        consultorio_id: '',
    });

    //método para realizar a usca de ususarios
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('/users', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    timeout: 10000
                });
                setUsuarios(response.data.data);
            } catch (e) {
                console.log(e);
            }
        };
        fetchData();
    }, [token]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('/tipousuario', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    timeout: 5000
                });
                setCargos(response.data.data);
            } catch (e) {
                console.log(e);
            }
        };
        fetchData();
    }, [token]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('/consultorios', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    timeout: 5000
                });
                setConsultorios(response.data.data);
            } catch (e) {
                console.log(e);
            }
        };
        fetchData();
    }, [token]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('/unidade', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    timeout: 5000
                });
                setUnidades(response.data.data);
            } catch (e) {
                console.log(e);
            }
        };
        fetchData();
    }, [token]);

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(formValues)
            setFormValues(formValues);
        axios.post('/funcionarios', formValues, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                handleClose();
                // exibe mensagem de sucesso com cor verde
                Swal.fire({
                    icon: "success",
                    title: "Sucesso!",
                    text: 'Cadastrado com sucesso',
                    footer: 'Agorao funcionário pode visualizar seu perfil nas configurações do sistema SUPPORT SGA'
                });
            })
            .catch((error) => {
                handleClose();
                console.log(error);
                Swal.fire({
                    icon: "error",
                    title: "Erro!",
                    text: error.response.data.error,
                    footer: error.response.data.exception.errorInfo[2]
                });
            });
    };
//constando com estilos
    const classes = useStyles();
    return (<Modal open={open} onClose={handleClose}>
        <div className={classes.root}>
            <CardHeader title="Cadastro de funcionários"/>
            <hr/>
            <form onSubmit={handleSubmit}>
                <Card className={classes.card}>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <InputLabel style={{padding: '0.5rem'}}>Nome Funcionário</InputLabel>
                            <Select
                                fullWidth
                                id="select"
                                size="small"
                                value={formValues.usuario_id}
                                onChange={(event) => setFormValues({
                                    ...formValues, usuario_id: event.target.value,
                                })}
                                variant="outlined"
                                displayEmpty
                                style={{height: '40.1px'}}
                            >
                                <MenuItem value="">Selecione o usuário</MenuItem>
                                {usuarios.map((usuario) => (<MenuItem key={usuario.id} value={usuario.id}>
                                    {(usuario.name).toUpperCase()}
                                </MenuItem>))}
                            </Select>
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel style={{padding: '0.5rem'}}>CPF</InputLabel>
                            <InputMask
                                mask="999.999.999-99"
                                value={formValues.cpf}
                                onChange={(event) => setFormValues({
                                    ...formValues, cpf: event.target.value,
                                })}>
                                {() => (<TextField
                                    fullWidth
                                    id="cpf"
                                    placeholder="CPF"
                                    variant="outlined"
                                    size="small"
                                />)}
                            </InputMask>
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel style={{padding: '0.5rem'}}>RG</InputLabel>
                            <InputMask
                                mask="99.999.999-9"
                                value={formValues.rg}
                                onChange={(event) => setFormValues({
                                    ...formValues, rg: event.target.value,
                                })}>
                                {() => (<TextField
                                    fullWidth
                                    id="rg"
                                    placeholder="RG"
                                    variant="outlined"
                                    size="small"
                                />)}
                            </InputMask>
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel style={{padding: '0.5rem'}}>Data nascimento</InputLabel>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                type={"date"}
                                variant="outlined"
                                size="small"
                                value={formValues.data_nascimento}
                                onChange={(event) => setFormValues({
                                    ...formValues, data_nascimento: event.target.value,
                                })}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel style={{padding: '0.5rem'}}>Sexo</InputLabel>
                            <Select
                                fullWidth
                                id="select"
                                size="small"
                                value={formValues.genero}
                                onChange={(event) => setFormValues({
                                    ...formValues, genero: event.target.value,
                                })}
                                variant="outlined"
                                displayEmpty
                                style={{height: '40.1px'}} // adicione esta linha
                            >
                                <MenuItem value="Selecione">Selecione</MenuItem>
                                <MenuItem value="masculino">Masculino</MenuItem>
                                <MenuItem value="feminino">Feminino</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={4}>
                            <InputLabel style={{padding: '0.5rem'}}>CNS</InputLabel>
                            <InputMask
                                mask="9999.9999.9999.999"
                                value={formValues.cns}
                                onChange={(event) => setFormValues({
                                    ...formValues, cns: event.target.value,
                                })}>
                                {() => (<TextField
                                    fullWidth
                                    id="rg"
                                    placeholder="CNS"
                                    variant="outlined"
                                    size="small"
                                />)}
                            </InputMask>
                        </Grid>
                        <Grid item xs={4}>
                            <InputLabel style={{padding: '0.5rem'}}>Cargo</InputLabel>
                            <Select
                                fullWidth
                                id="select"
                                size="small"
                                value={formValues.tipo_usuario_id}
                                onChange={(event) => setFormValues({
                                    ...formValues, tipo_usuario_id: event.target.value,
                                })}
                                variant="outlined"
                                displayEmpty
                                style={{height: '40.1px'}}
                            >
                                <MenuItem value="">Selecione o cargo</MenuItem>
                                {cargos.map((cargo) => (<MenuItem key={cargo.id} value={cargo.id}>
                                    {cargo.tipo_usuario}
                                </MenuItem>))}
                            </Select>
                        </Grid>
                        <Grid item xs={4}>
                            <InputLabel style={{padding: '0.5rem'}}>Unidade de atuação</InputLabel>
                            <Select
                                fullWidth
                                id="select"
                                size="small"
                                value={formValues.unidade_id}
                                onChange={(event) => setFormValues({
                                    ...formValues, unidade_id: event.target.value,
                                })}
                                variant="outlined"
                                displayEmpty
                                style={{height: '40.1px'}}
                            >
                                <MenuItem value="">Selecione a unidade</MenuItem>
                                {unidades.map((unidade) => (<MenuItem key={unidade.id} value={unidade.id}>
                                    {unidade.descricao}
                                </MenuItem>))}
                            </Select>
                        </Grid>
                        <Grid item xs={4}>
                            <InputLabel style={{padding: '0.5rem'}}>Consultório alocador</InputLabel>
                            <Select
                                fullWidth
                                id="select"
                                size="small"
                                value={formValues.consultorio_id}
                                onChange={(event) => setFormValues({
                                    ...formValues, consultorio_id: event.target.value,
                                })}
                                variant="outlined"
                                displayEmpty
                                style={{height: '40.1px'}}
                            >
                                <MenuItem value="">Selecione o consultório </MenuItem>
                                {consultorios.map((consultorio) => (
                                    <MenuItem key={consultorio.id} value={consultorio.id}>
                                        {consultorio.consultorio}
                                    </MenuItem>))}
                            </Select>
                        </Grid>
                    </Grid>
                </Card>
                <CardActions>
                    <Button id="success" variant="contained" size="small" type="submit">
                        <i className="fa-solid fa-plus"></i> Salvar
                    </Button>
                    <Button color="secondary" variant="contained" size="small" onClick={handleClose}>
                        <i className="fa-solid fa-remove"></i> cancelar
                    </Button>
                </CardActions>

            </form>
        </div>
    </Modal>);
};

export default ModalFuncionarios;
